import * as skedApiAll from "../_skedApi";
import { GeneratedSkedApiClient } from "../generated-client";
import type { paths } from "../generated/sked-api-openapi-types";
import { StockImage } from "./types";

const generatedSkedApiClient = new GeneratedSkedApiClient<paths>();
let legacySkedApiOverride: typeof skedApiAll.skedApi | null = null;

type GetCuratedStockImagesOperation =
  paths["/content-inbox/stock-images/curated"]["get"];
type GetStockImagesOperation =
  paths["/content-inbox/stock-images/{query}"]["get"];

export function setMediaLibrarySkedApiInGetStockImages(
  customSkedApi: typeof skedApiAll.skedApi
) {
  legacySkedApiOverride = customSkedApi;
}

export async function getStockImages(
  query: string | null,
  page: number,
  limit: number
): Promise<StockImagesResponse> {
  const search = query || "curated";

  if (legacySkedApiOverride) {
    const { data } = await legacySkedApiOverride.get(
      `/content-inbox/stock-images/${search}`,
      {
        params: { page, limit },
      }
    );
    return data;
  }

  const params = { query: { page, limit } };
  const result =
    search === "curated"
      ? await generatedSkedApiClient.client.GET(
          "/content-inbox/stock-images/curated",
          {
            params: params as GetCuratedStockImagesOperation["parameters"] & {
              query: { page: number; limit: number };
            },
          }
        )
      : await generatedSkedApiClient.client.GET(
          "/content-inbox/stock-images/{query}",
          {
            params: {
              ...params,
              path: { query: search },
            } as GetStockImagesOperation["parameters"],
          }
        );

  return (await generatedSkedApiClient.unwrap(result)) as StockImagesResponse;
}

interface StockImagesResponse {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  data: StockImage[];
}
